import type { EntityAction } from "@firecms/core";
import { HowToRegIcon } from "@firecms/ui";
import type { EventUser } from "../../collections/eventUsers";
import { getAdminT } from "../../i18n/getAdminT";
import { getAdminUiLocale } from "../../i18n/getAdminUiLocale";
import { tableOnlyEntityAction } from "../entityActionDefaults";
import { openApproveStandbyDialog } from "./approveStandbyBridge";

export function buildApproveStandbyEntityAction(
  _accountId: string,
  _eventId: string
): EntityAction<EventUser> {
  const t = getAdminT(getAdminUiLocale());

  return {
    key: "approve-standby",
    name: t("approveStandby.entityAction"),
    icon: <HowToRegIcon />,
    ...tableOnlyEntityAction,
    collapsed: false,
    onClick: async ({ entity }) => {
      if (!entity) {
        return;
      }
      const userId = entity.values.uid || entity.id;
      openApproveStandbyDialog(userId, entity.values.standbyReason);
    },
  };
}
